var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-white"},[_c('strong',[_vm._v("DISCLAIMER:")]),_vm._v(" This content is provided and hosted by a 3rd party server. Sometimes these servers may include advertisements. MotoGPRewind does not host or upload this material and is not responsible for the content. ")])
}]

export { render, staticRenderFns }